import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

/**
 * Hooks to check when the screen is mobile or not. It is based on the material useMediaQuery
 * @param { Breakpoint } [breakpointKey=sm] breakpointKey
 */
const useIsMobile = (breakpointKey: Breakpoint | number = 'sm') => {
  const muiTheme = useTheme();
  return useMediaQuery(muiTheme.breakpoints.down(breakpointKey));
};

export default useIsMobile;
